<template>
  <div id="app">
    <KoPollutants />
  </div>
</template>

<script>
import KoPollutants from "../../components/KoPollutants";

export default {
  name: 'App',
  components: {
    KoPollutants,
  }
}
</script>
